<template>
  <div class="appcontent">
    <div class="nav-header">
      <div class="content" id="navContent">
        <!--导航-->
        <div  class="navcontent" >
          <div @click="jump('#Abouta')" class="l">
            <img src="@/assets/m/Index/logo.png" alt="" />
            <!-- <div class="title1">Transformers</div> -->
          </div>
          <!-- <img class="r" @click="showNav" src="@/assets/m/menu@2x.png" alt="" /> -->
          <div class="r">
            <div class="signin" @click="login" v-if="userEmail == null">
              Sign in
            </div>
            <div class="signin1" @click="showaddressbox" v-else>
              {{ userEmail }}
            </div>
            <img src="@/assets/m/Index/right.png" @click="showNav" />
          </div>
        </div>
        <!--消息公告-->
        <di class="message">
          <div class=" marquee-container" >
            <div class="marquee-content" :style="marqueeStyle"  @click="noteClick">
              <div class="marquee-message">
                <img src="@/assets/pc/Index/note.png" />
                <span style="margin: 0 5px;">{{ message }}</span>
                <img src="@/assets/pc/Index/point.png" />
              </div>
            </div>
          </div>
        </di>
      </div>

      <div
        class="addressbox addressbox1"
        v-if="isBindAddress == 0"
        v-show="testflog"
        @mouseover="showaddressbox"
        @mouseout="hideaddressbox"
      >
        <img
          class="close"
          src="../../assets/pc/Login/close.png"
          @click="bindclose"
        />
        <div class="boxli boxlis">
          <div class="boxlitit">USDT Lock-up Address:</div>
          <div class="boxlicon">Not yet bound</div>
        </div>
        <!-- <div class="boxli">
          <div class="boxlitit">DO Lock-up Address:</div>
          <div class="boxlicon">Not yet bound</div>
        </div> -->
        <div class="boxli">
          <div class="boxlitit">Token/NFT Receiving Address:</div>
          <div class="boxlicon">Not yet bound</div>
        </div>
        <div class="boxbind">
          <div class="exit" @click="Exits">Exit</div>
          <div class="bind" @click="bindclick">Bind wallet address</div>
        </div>
      </div>
      <div
        class="addressbox addressbox2"
        v-show="testflog"
        v-if="isBindAddress == 1"
        @mouseover="showaddressbox"
        @mouseout="hideaddressbox"
      >
        <img
          class="close"
          src="../../assets/pc/Login/close.png"
          @click="bindclose"
        />
        <div class="boxli">
          <div class="boxlitit">USDT Locked Address ({{ coinType }}):</div>
          <div class="boxlicon">
            {{ donationAddress }}
            <!-- <img src="../../assets/pc/Login/update.png" @click="update" /> -->
          </div>
        </div>
        <!-- <div class="boxli boxlis">
          <div class="boxlitit">DO Locked Address:</div>
          <div class="boxlicon"></div>
        </div> -->
        <div class="boxli boxlis">
          <div class="boxlitit">Token/NFT Receiving Address(DO Network):</div>
          <div class="boxlicon">{{ xprlAddress }}</div>
        </div>
        <div class="boxli boxlis boxbox">
          <div class="boxlitit">USDT locked transaction hash:</div>
          <div class="boxlicon">
            <input
              type="text"
              placeholder="Please provide the transaction hash for the locked USDT."
              v-model.trim="coinTxHash"
              ref="search"
            />
          </div>
          <div class="boxlitit">DO locked transaction hash:</div>
          <div class="boxlicon">
            <input
              type="text"
              placeholder="Please provide the transaction hash for the locked DO."
              v-model.trim="txHash"
              ref="search"
            />
          </div>
        </div>
        <div class="recordbox">
          <div class="record" @click="recordlist">PRL-X receiving record</div>
          <div class="record1" @click="hashsubmit">Submit</div>
          <!-- <div class="record11" @click="hashsubmit1">submit</div> -->
        </div>
        <div class="Reminder">
          <div class="Remindertit">Reminder:</div>
          <div class="Remindercon">
            Please ensure that the transaction hash you submit is the
            transaction hash of the lock-up address bound above.
          </div>
          <div class="Remindercon1" @click="Exits">Exit</div>
        </div>
      </div>

      <!-- 退出登录开始 -->
      <Logout
        v-show="lflog"
        :lflog="lflog"
        @logouts="logouts($event)"
        @email="email($event)"
        @isBind="isBind($event)"
        @loginflog="loginflog($event)"
      ></Logout>
      <!-- 退出登录结束 -->
      <!-- 登录开始 -->
      <Login
        v-show="flog"
        :flog="flog"
        :flogb="flogb"
        @loginflog="loginflog($event)"
        @signups="signups($event)"
        @fflog="fflog($event)"
        @email="email($event)"
        @isBind="isBind($event)"
        @donation="donation($event)"
        @xprl="xprl($event)"
        @coinTypes="coinTypes($event)"
      ></Login>
      <!-- 登录结束 -->
      <!-- 注册开始 -->
      <Signup
        v-show="flogb"
        :flogb="flogb"
        :flog="flog"
        @signups="signups($event)"
        @loginflog="loginflog($event)"
      ></Signup>
      <!-- 注册结束 -->
      <!-- 忘记密码开始 -->
      <Resignup
        v-show="flogc"
        :flogc="flogc"
        @loginflog="loginflog($event)"
        @repwd="repwd($event)"
        @back="back($event)"
      ></Resignup>
      <!-- 忘记密码结束 -->
      <!-- 绑定开始 -->
      <Bind
        v-show="bflog"
        :bflog="bflog"
        @bloginflog="bloginflog($event)"
        @donation="donation($event)"
        @xprl="xprl($event)"
        @isBind="isBind($event)"
        @coinTypes="coinTypes($event)"
      ></Bind>
      <!-- 绑定结束 -->
      <!-- 提交的记录开 -->
      <Record
        v-show="rflog"
        :rflog="rflog"
        @bloflog="bloflog($event)"
        :relist="relist"
        :total="total"
      ></Record>
      <!-- 提交的记录结束 -->
      <!-- 公告打开 -->
      <Note
        v-show="rflog"
        :rflog="rflog"
        @bloflog="bloflog($event)"
      ></Note>
      <!-- 公告结束 -->

      <van-popup v-model="shows1">
        <div class="navTag">
          <!-- popup内的nav -->
          <div class="navtitle">
            <div class="l logo" @click="jump('#Abouta')">
              <img src="@/assets/m/Index/logo.png" />
              <!-- <div class="title1">Transformers</div> -->
            </div>
            <!-- <img
              class="r"
              @click="shows1 = false"
              src="@/assets/m/caidan.png"
              alt=""
            /> -->
            <div class="r" @click="shows1 = false">Close</div>
          </div>
          <div class="headermenu">
            <div class="menuli" @click="jump('#About')">About</div>
            <div class="menuli" @click="jump('#Mission')">
              Investment Direction
            </div>
            <div class="menuli" @click="jump('#Service')">
              Investment Process
            </div>
            <div class="menuli" @click="jump('#Stratagem')">NFT Plan</div>
            <div class="menuli" @click="jump('#Contact')">
              Participation Avenues
            </div>
            <div class="menuli" @click="jump('#Foundation')">Foundation</div>
            <div class="menuli" @click="jump('#Products')">
              Investment products
            </div>
          </div>
          <!-- <div class="headermenu1">
            <div class="headertip" @click="toggleVisibilitya">
              <div class="headertipl">Social</div>
              <div class="headertipr">
                <img :src="isVisiblea == true ? imgloga : imglogo" />
               
              </div>
            </div>
            <div class="headerlist" v-if="isVisiblea">
              <a href="https://twitter.com/faircrypt01" target="_blank">
                <div>X</div></a
              >
              <a href="https://medium.com/@faircrypto" target="_blank"
                ><div>Medium</div></a
              >
             
              <a
                href="https://mirror.xyz/0x23A1E6cd8196Caad2548240bd662b87Ae7ed2D08/subscribe"
                target="_blank"
                ><div>Mirror</div></a
              >
              
            </div>
          </div> -->
        </div>
      </van-popup>
    </div>
    <div class="content-topa" id="Abouta"></div>
    <div class="content-top">
      <div class="Aboutbg">
        <div class="Aboutitle">TO BECOME</div>
        <div class="Aboutcon">
          <span>A</span> knowledgeable<br />
          Web<span>3</span> accredite<span>d</span> investo<span>r</span>
        </div>
        <div class="Aboutcon1">Fund</div>
        <div class="Aboutbotm">
          <div class="Aboutbotml">
            Fair, Transparent,<br />
            Decentralized, Rational <br />Investment, Avoiding<br />
            becoming a 'bagholder.'
          </div>
          <div class="Aboutbotmr">
            <!-- <img src="@/assets/pc/Index/xia.png" /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="content-toptop" id="About"></div>
    <div class="content-top1">
      <div class="top1titl">
        <div class="aboutMission">
          About<img src="@/assets/m/Index/dian.png" />
        </div>
        <div class="aboutli aboutli1">
          <div class="aboutcon">
            <div class="aboutcon">
              <span>FairCrypto Fund is </span>a novel financial institution in
              the form<br />
              of a decentralized organization aimed at building a <br />diverse
              digital financial ecosystem to meet the needs<br />
              and preferences of global users. We focus on providing
              <br />secure and efficient digital financial services, covering<br />
              areas such as AI computing power, DEPIN, incubation,
              <br />investment, facilitating the transition of Web2 enterprises
              <br />to Web3, Staking, and BTClayer2.
            </div>
            <!-- <img src="@/assets/m/Index/2.png" /> -->
          </div>
        </div>
        <div class="aboutli">
          <div class="aboutcon">
            <div class="abouttit">Mission</div>
            <div class="aboutcon">
              <span>Our mission is </span> to establish a fair, transparent,
              and<br />
              decentralized crypto fund system, resisting market
              <br />manipulation and speculative activities, encouraging<br />
              rational investment, and assisting investors in avoiding<br />
              speculative risks.
            </div>
            <img src="@/assets/m/Index/2.png" class="img1" />
          </div>
        </div>
        <div class="aboutli" style="margin-top: 48px">
          <div class="aboutcon">
            <div class="abouttit">Vision</div>
            <div class="aboutcon">
              <span>We are </span>committed to establishing a fair, just, and<br />
              transparent cryptocurrency market, rejecting a culture of<br />
              speculation, and working together with partners to <br />become
              leaders in the WEB3 industry.
            </div>
            <img src="@/assets/m/Index/3.png" class="img2" />
          </div>
        </div>
        <div class="aboutli" style="margin-top: 58px">
          <div class="aboutcon">
            <div class="abouttit">Goals</div>
            <div class="aboutcon">
              <span>Our goal is </span> to address various challenges faced
              by<br />
              investors, including improving the balance of investment<br />
              returns, enhancing the professionalism of investment<br />
              project evaluations, identifying high-quality investment
              <br />opportunities, and providing financial support to help<br />
              investors better participate in the cryptocurrency market.
            </div>
            <img src="@/assets/m/Index/4.png" class="img3" />
          </div>
        </div>
      </div>
    </div>
    <div class="content-top1a" id="Mission"></div>

    <div class="content-top2">
      <div class="Main-w">
        <div class="aboutMission">
          Investment<br />
          Direction<img src="@/assets/m/Index/dian.png" />
        </div>
        <img src="@/assets/m/Index/23.png" />
      </div>
    </div>
    <div class="content-top2a" id="Service"></div>
    <div class="content-top3">
      <div class="top3titl">
        <div class="aboutMission">
          Investment<br />
          Process<img src="@/assets/m/Index/dian.png" />
        </div>
        <div class="Processbox">
          <!-- <img  src="@/assets/m/Index/24.png" /> -->
          <div class="Processimg">
            <div class="div1">User Contribution</div>
            <div class="div2">
              Foundation<br />
              Multisig Address
            </div>
            <div class="div3">
              Foundation<br />
              Investment<br />
              Targets
            </div>
            <div style="display: flex; justify-content: space-between">
              <div class="div4">24/30 Multisig</div>
              <div class="div5">Foundation Earnings</div>
            </div>
            <!-- 百分比开始 -->
            <!-- <div class="bfb">
              <div class="icons">50%</div>
              <div class="icons1">50%</div>
            </div>
            <div class="bfb1">
              <div class="icons">20%</div>
              <div class="icons1">80%</div>
            </div>
            <div class="bfb2">
              <div class="icons">10%</div>
              <div class="icons1">90%</div>
            </div> -->
            <!-- 百分比结束 -->
            <!-- <div class="pbox">
              <div class="div7">
                <div class="diva">50%</div>
                <div class="divb">
                  Participated by<br />
                  the Foundation
                </div>
              </div>
              <div class="div8">
                <div class="diva">50%</div>
                <div class="divb">
                  Participated by<br />
                  NFT-Holding<br />
                  Users (Limited<br />
                  Time)
                </div>
              </div>
            </div>

            <div class="pbox">
              <div class="div9">
                <div class="diva">20%</div>
                <div class="divb">of Earnings<br/> Goes to the<br/> Foundation</div>
              </div>
              <div class="div10">
                <div class="diva">80%</div>
                <div class="divb">Goes to Users</div>
              </div>
            </div> -->
            <div class="div6">
              Partially Abandoned for Foundation<br />
              Participation
            </div>
            <!-- 
            <div class="pbox">
              <div class="div11">
                <div class="diva">10%</div>
                <div class="divb">Goes to<br/> Signatur<br/>e NFT</div>
              </div>
              <div class="div12">
                <div class="diva">90%</div>
                <div class="divb">
                  Distributed<br />
                  Based on All<br />
                  User<br />
                  Contributions
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="content-top4a" id="Stratagem"></div>
    <div class="content-top4">
      <div class="top4_main">
        <div class="aboutMission">
          NFT Plan<img src="@/assets/m/Index/dian.png" />
        </div>
        <img class="Nftimg" src="@/assets/m/Index/11.png" />
        <div class="Nftcon">
          <img src="@/assets/m/Index/12.png" /><span>Regular NFTs(96%)</span>
        </div>
        <div class="Nftcon1">
          <img src="@/assets/m/Index/13.png" /><span>Signature NFTs(4%)</span>
        </div>
        <div class="Nftli">
          <div class="Nftlileft">
            <div class="Nftdian"></div>
            <div class="Nftline lineheight"></div>
          </div>
          <div class="Nftliright">
            The initial release includes<span> 5,200 NFTs</span>, with
            <span>5,000 being <br />regular NFTs</span>
            and <span>200 being signature NFTs</span>, both<br />
            serving as tokens for entry into the foundation.
          </div>
        </div>
        <div class="Nftli">
          <div class="Nftlileft">
            <div class="Nftdian"></div>
            <div class="Nftline lineheight1"></div>
          </div>
          <div class="Nftliright">
            In the initial phase,<span> 30 signature NFTs</span> and<span>
              2,500 regular<br />
              NFTs</span
            >
            will be airdropped.
          </div>
        </div>
        <div class="Nftli">
          <div class="Nftlileft">
            <div class="Nftdian"></div>
            <div class="Nftline lineheight2"></div>
          </div>
          <div class="Nftliright">
            The remaining regular NFTs will be publicly available for<br />
            sale by the foundation at a price of <span>10 USDT</span> per
            token,<br />
            with the proceeds going to the foundation.
          </div>
        </div>
        <div class="Nftli">
          <div class="Nftlileft">
            <div class="Nftdian"></div>
          </div>
          <div class="Nftliright">
            NFT holders can participate in the foundation's<br />
            investment research related to specific projects.
          </div>
        </div>
        <div class="Nftli">
          <div class="Nftlirighta">
            <span> For example</span>, if the foundation participates with<span>
              50%</span
            >
            of <br />
            the allocation in Project A, the remaining <span>50% </span>is open
            <br />
            for participation by NFT holders within a specified <br />
            timeframe. If the deadline passes, the foundation will<br />take up
            the remaining allocation.
          </div>
        </div>
      </div>
    </div>
    <div class="content-top5a" id="Team"></div>
    <!-- <div class="content-top5">
      <div class="top5_main">
        <img src="@/assets/m/indexpic/team.png" />
        <div class="top5_box">
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
          <div class="top5_boxul">
            <div class="top5_boxli">
              <img src="@/assets/m/indexpic/teama.png" />
            </div>
            <div class="top5_text">milaoshu</div>
            <div class="top5_con">milaoshu</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="content-top6a" id="Contact"></div>
    <div class="content-top6">
      <div class="top6_main">
        <div class="Foundationtip">
          Ways to <br />Participate in<br />the Foundation
          <img src="@/assets/pc/Index/dian.png" />
        </div>
        <div class="Foundationli">
          <div class="Foundationlibox">
            <div class="Foundcon">1</div>
            <div class="concontent">1000</div>
            <img class="img" src="@/assets/pc/Index/13.png" />
            <div class="concontent">+ Locking 2000</div>
            <img class="img1" src="@/assets/pc/Index/20.png" />
            <div class="concontent1">(tokens)</div>
          </div>
          <div class="Foundationlibox">
            <img class="img2" src="@/assets/pc/Index/14.png" />
            <div class="concontent2">500PRL + Owning 1 regular NFT</div>
          </div>
        </div>
        <div class="Foundline"></div>
        <div class="Foundationli">
          <div class="Foundationlibox">
            <div class="Foundcon">2</div>
            <div class="concontent">30000</div>
            <img class="img" src="@/assets/pc/Index/13.png" />
            <div class="concontent">+ Locking 50000</div>
            <img class="img1" src="@/assets/pc/Index/20.png" />
            <div class="concontent1">(tokens)</div>
          </div>
          <div class="Foundationlibox">
            <img class="img2" src="@/assets/pc/Index/14.png" />
            <div class="concontent2">30000PRL + Owning 1 signature NFT</div>
          </div>
        </div>
        <div class="Foundbox">
          <div class="Foundboxli">
            The Foundation membership asset lock-up period is<br />
            18 months, and the locked DO will be used for node <br />delegation.
            The earnings generated from node <br />delegation will belong to the
            Foundation.
          </div>
          <div class="Foundboxli Foundboxlia">
            10% of the fund's profits will be allocated to users who own the
            signed NFTs, another 10% will be used for fund operations, and the
            remaining 80% will be distributed to all participating users in
            proportion to their invested funds.
          </div>
          <div class="Foundboxli" style="padding-top: 14px">
            The PRL tokens airdropped by the Foundation have free<br />
            liquidity.The quantity of PRL issued is generated based <br />on the
            amount of USDT flowing into the foundation.
          </div>
        </div>
        <!-- <div class="Foundboxline" @click="toggleVisibility">
          To view the addresses of NFT holders<img
            src="@/assets/m/Index/xia.png"
          />
        </div> -->
        <div class="Foundboxall" v-if="isVisible">
          <div class="tab">
            <button
              v-for="(tab, index) in tabs"
              :key="index"
              @click="activeTab = index"
              :class="{ active: activeTab === index }"
            >
              {{ tab.title }}
            </button>
          </div>
          <div class="tab-content">
            <div v-if="activeTab == 0">
              <div class="nodata">List is empty</div>
              <!-- <div class="tabcontent">
               
                <div class="tabtitle">Address</div>
                <div class="tabbox">
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                </div>
              </div> -->
            </div>
            <div v-if="activeTab == 1">
              <div class="nodata">List is empty</div>
              <!-- <div class="tabcontent">
                <div class="nodata">List is empty</div>
                <div class="tabtitle">Address</div>
                <div class="tabbox">
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                  <div class="tabboxli">14PxAiEk8KJvEfhuJueMq7cFQwBNQuk6Av</div>
                </div>
              </div> -->
            </div>
            <!-- <div
              v-for="(tab, index) in tabs"
              :key="index"
              v-show="activeTab === index"
            >
             
              {{ tab.content }}
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="Foundationa" id="Foundation"></div>
    <div class="Foundation">
      <div class="Main-w">
        <div class="aboutMission">
          Foundation <img src="@/assets/m/Index/dian.png" />
        </div>
        <div class="Foundationcon">
          Our trading accounts operate with complete<br />
          transparency, whether on decentralized or centralized<br />
          exchanges, making all transaction information<br />
          accessible to the public. To ensure the security of funds,<br />
          we have established a rigorous monitoring system. All<br />
          inflows and outflows of funds will be publicly disclosed<br />
          for the supervision of our users.
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="Main-w">
        <div class="footerli">
          <img src="@/assets/m/Index/a.png" />
          <div class="footerlicon">
            Here is the public address information for the Foundation:
          </div>
        </div>
        <div class="footerlia">
          USDT Receiving Address:<span
            ><br />(Please use the address filled in the Foundation BOT to
            transfer.)</span
          >
        </div>
        <div class="footerlib" style="display: flex">
          <img src="@/assets/pc/Index/aaaa.png" />
          <div>0x88482E889a13CD0c6b99C4BD6e80539983bEdadC</div>
        </div>
        <div class="footerlib" style="display: flex">
          <img src="@/assets/pc/Index/aa.png" />
          <div>TKh5H1UsQgfbbktDhsAKdp3FHSL9PY3eXK</div>
        </div>
        <div class="footerlib" style="display: flex">
          <img src="@/assets/pc/Index/aaa.png" />
          <div>0x5B2573F49ec4f12dAd9B2eA9Da6D98c25A202Ab3</div>
        </div>

        <div class="footerlia">DO Receiving Address:</div>
        <div class="footerlib">0x8Be0450dFb3c26485Cc9F7CC2ee2B83FB5B496eA</div>
        <div class="footerlia">Foundation Donation Address(DO):</div>
        <div class="footerlib">0xBBB1f96101886BD2b356fc3F8AC4D144da131c1C</div>
      </div>
    </div>
    <!-- 产品开始 -->
    <div id="Products"></div>
    <div class="Products">
      <div class="Productsallbox">
        <div class="Productstit">
          Investment products <img src="@/assets/pc/Index/dian.png" />
        </div>
        <div class="Productsbox">
          <div v-for="(item, index) in listitems" :key="index">
            <div
              class="pboxli"
              @mouseleave="hidetoggleDetails"
              @touchmove="handleTouchMove"
              @click="toggleDetails(index)"
            >
              <div class="pboxlibox">
                <img
                  class="imgs"
                  v-if="index == 0"
                  src="@/assets/pc/Login/1.jpg"
                />
                <img
                  class="imgs"
                  v-if="index == 1"
                  src="@/assets/pc/Login/2.jpg"
                />
                <img
                  class="imgs"
                  v-if="index == 2"
                  src="@/assets/pc/Login/3.jpg"
                />
                <img
                  class="imgs"
                  v-if="index == 3"
                  src="@/assets/pc/Login/do.png"
                />
                <!-- <img class="imgs" src="@/assets/pc/Login/1.png" /> -->
                <div class="pboxlitit">{{ item.productName }}</div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Investment target:</div>
                  <div class="pboxliright pboxlirighta">
                    {{ item.markNameStr }}
                  </div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Total return:</div>
                  <div class="pboxliright">{{ item.totalProfit }} U</div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Total return rate:</div>
                  <div class="pboxliright">{{ item.totalProfitRate }} %</div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Amount:</div>
                  <div class="pboxliright">{{ item.holdAmount }}</div>
                </div>
                <div class="pboxlicon">
                  <div class="pboxlileft">Address:</div>
                  <div class="pboxliright addrs" v-if="index == 0">
                    1PNuvwszjFqueNz3SDNN7iYaVK59kqVPbU
                  </div>
                  <div class="pboxliright addrs" v-if="index == 1">
                    0x63c7746af7167af7109e013cc8863d7552f309d1
                  </div>
                  <div class="pboxliright addrs" v-if="index == 2">
                    3qtQK64oY2dYswaMcKs57rLX8WFL3g37gEM8vq2RHFaL
                  </div>
                  <div class="pboxliright addrs" v-if="index == 3">
                    0xa438Bf9FF1FaBEE0c22f95c974D683A750cfae39
                  </div>
                </div>
                <div class="pboxline"></div>

                <div
                  class="pboxviews"
                  @click="debounceToggleDetails(index)"
                  v-if="detailsVisible !== index"
                >
                  View Details<img
                    class="imgview"
                    src="@/assets/pc/Login/4.png"
                  />
                </div>
                <div
                  class="pboxviews"
                  v-if="detailsVisible == index && markList.length == 0"
                >
                  View Details<img
                    class="imgview"
                    src="@/assets/pc/Login/4.png"
                  />
                </div>
                <div
                  v-if="detailsVisible === index"
                  :class="markList.length > 0 ? 'pboxboxs' : ''"
                >
                  <div class="pboxlibox">
                    <div v-for="(item, index) in markList" :key="index">
                      <div class="pboxlitit">{{ item.markName }}</div>
                      <div class="pboxlicon">
                        <div class="pboxlileft">Holding cost:</div>
                        <div class="pboxliright">{{ item.holdCost }} U</div>
                      </div>
                      <div class="pboxlicon">
                        <div class="pboxlileft">Holding period:</div>
                        <div class="pboxliright">{{ item.holdTime }}</div>
                      </div>
                      <div class="pboxlicon">
                        <div class="pboxlileft">Holding price:</div>
                        <div class="pboxliright">{{ item.holdPrice }} U</div>
                      </div>

                      <div
                        class="pboxline"
                        v-if="index < markList.length - 1"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品结束 -->

    <div class="footer">
      <div class="Main-w">
        <!-- <div class="footerli">
          <img src="@/assets/m/Index/a.png" />
          <div class="footerlicon">
            Here is the public address information for the Foundation:
          </div>
        </div>
        <div class="footerlia">USDT Receiving Address:</div>
        <div class="footerlib" style="display: flex">
          <img src="@/assets/pc/Index/aaaa.png" />
          <div>0x88482E889a13CD0c6b99C4BD6e80539983bEdadC</div>
        </div>
        <div class="footerlib" style="display: flex">
          <img src="@/assets/pc/Index/aa.png" />
          <div>TKh5H1UsQgfbbktDhsAKdp3FHSL9PY3eXK</div>
        </div>
        <div class="footerlib" style="display: flex">
          <img src="@/assets/pc/Index/aaa.png" />
          <div>0x5B2573F49ec4f12dAd9B2eA9Da6D98c25A202Ab3</div>
        </div>

        <div class="footerlia">DO Receiving Address:</div>
        <div class="footerlib">1EFcFATnYPgbaYNNKS4e9xQ9Rbjd6YTark</div>
        <div class="footerlia">Foundation Donation Address(DO):</div>
        <div class="footerlib">1AsCSDeuggp2GdD3o44TaeoCfUdevTi1kK</div> -->
        <div class="footerli">
          <img src="@/assets/m/Index/b.png" />
          <div class="footerlicon">
            Subscribe to our newsletter to receive the latest updates and
            important announcements.
          </div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          prop="email"
          ref="ruleForm"
          class="demo-dynamic"
          autocomplete="off"
        >
          <el-form-item prop="email">
            <el-input v-model="ruleForm.email" placeholder="Enter your email">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm(ruleForm.email)"
              >Subscribe now</el-button
            >
          </el-form-item>
        </el-form>
        <div class="apks">
          <div class="title">FairCrypto Fund Download</div>
          <a href="https://www.faircrypto.fund/apk/FairCrypto.apk"> <div class="download">Download APK</div></a>
        </div>
        <div class="footerbottom">
          <img class="bottomimg" src="@/assets/m/Index/logo.png" />
          <div class="bottombox">
            <img src="@/assets/m/Index/21.png" />
            2024 - FairCrypto Find, Lnc.
          </div>
          <div class="footermain">
            <div class="footermainl">
              <div class="div1">Invest Email :</div>
              <div class="div2">serve@faircrypto.fund</div>
              <div class="div3">
                Strong Collaboration, Leading<br />
                the WEB3 Industry.
              </div>
              <div class="div4" @click="jump('#Abouta')">
                Back to top <img src="@/assets/m/Index/22.png" />
              </div>
            </div>
            <div class="footermainr">
              <a href="https://twitter.com/faircrypt01" target="_blank"
                ><div>X</div></a
              >
              <a href="https://medium.com/@faircrypto" target="_blank">
                <div>Medium</div></a
              >
              <!-- <div>Youtube</div> -->
              <a
                href="https://mirror.xyz/0x23A1E6cd8196Caad2548240bd662b87Ae7ed2D08/subscribe"
                target="_blank"
              >
                <div>Mirror</div></a
              >
              <!-- <div>Telegram</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubStr } from "@/utils/utils";
import { Collapse, CollapseItem } from "vant";
import {
  GetEmail,
  SendEmail,
  GetProductList,
  GetInfo,
  GetTranstionList,
  GettProduct,
} from "@/assets/server/api.js";
import Resignup from "../../views/m/Login/Resignup";
import Login from "../../views/m/Login/Login.vue";
import Logout from "../../views/m/Login/Logout.vue";
import Signup from "../../views/m/Login/Signup.vue";
import Record from "../../views/m/Login/Record.vue";
import Bind from "../../views/m/Login/Bind.vue";
import Note from "../../views/m/Login/Note.vue";
import Vue from "vue";
const echarts = require("echarts");
export default {
  components: {
    // Login,
    // CheckUser,
    Collapse,
    CollapseItem,
    Login,
    Signup,
    Bind,
    Record,
    Resignup,
    Logout,
    Note,
    // ShowMoney,
  },
  name: 'Message',
  props: {
    message: {
      type: String,
      default: 'Important update, please click it!'
    },
    duration: {
      type: Number,
      default: 15 // 动画持续时间（秒）
    }
  },
  watch: {
    $route: {
      handler: function (to, form) {
        // if (to.path === "/Index") {
        //  console.log(111);
        if (localStorage.getItem("email") == null) {
          if (to.query.userEmail !== undefined) {
            this.userEmail = getSubStr(to.query.userEmail, 0, 4);
          }
          this.userEmail = null;
        } else {
          this.userEmail = getSubStr(localStorage.getItem("email"), 0, 4);
          // console.log(this.userEmail);
        }
        // }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      lflog: false, //退出登录
      relist: [],
      pageNum: 1,
      total: null,
      xprlAddress: "",
      coinType: "",
      donationAddress: "",
      listitems: [], // Assuming these are your items
      markList: [],
      detailsVisible: null,
      debounceTimeout: null,
      rflog: false,
      testflog: false,
      isBindAddress: "",
      jwtToken: "",
      userEmail: "",
      userId: "",
      coinTxHash: "", //捐赠hash
      txHash: "", //交易hash
      flogs: false,
      flogs1: true,
      flog: false,
      flogb: false,
      flogc: false,
      bflog: false,
      flog1: false,
      imglogo: require("@/assets/m/Index/xia1.png"),
      imgloga: require("@/assets/m/Index/shang1.png"),
      isVisiblea: false,
      ruleForm: { email: "" },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            // message: "Please input email",
            trigger: "blur",
          },
        ],
      },
      activeTab: 0, // 默认激活的选项卡的索引
      tabs: [
        { title: "Signature NFTs", content: "Content of Tab 1" },
        { title: "Regular NFTs", content: "Content of Tab 2" },
      ],
      isVisible: false, // 初始时为true，表示元素可见
      form: {
        intro: '', //介绍
        Name: '',
        emails: '',
      },
      rules: {},
      shows1: false, // popup显示隐藏
      shows2: false,
      moneyAddress: '',
      activeName: '',
      // navList: navList,
      headerclass: true,
      show: false,
      type: '',
      userName: '',
      isLogin: true,
      dialogType: '',
      dialogVisible: false,
      userMenu: false,
      usersStatus: '',
      Scolor: '',
      form: {
        content: '', // 介绍
        fullName: '',
        email: '',
      },
      rules: {
        // 第一部分效验开始
        // 第一部分效验结束
      },
      btnShow: false,
      widthPre: "",
      percentage: 16,
      percentagea: 10,
      percentageb: 10,
      percentagec: 10,
      percentaged: 10,
      customColor: "#0B27F1",
      timer: "",
    };
  },
  computed: {
    marqueeStyle() {
      return {
        animationDuration: `${this.duration}s`
      };
    }
  },
  created() {
    this.userEmail = localStorage.getItem("email");
    this.xprlAddress = localStorage.getItem("xprl");
    this.donationAddress = localStorage.getItem("donation");
    this.coinType = localStorage.getItem("coinTypes");
  },
  destroyed() {},
  mounted() {
    this.GetProductLists();
    if (
      this.userEmail !== "" ||
      this.userEmail !== null ||
      this.userEmail !== undefined
    ) {
      this.userEmail = localStorage.getItem("email");
      //console.log(this.userEmail);
      this.userId = localStorage.getItem("userId");
      this.jwtToken = localStorage.getItem("jwtToken");
      this.isBindAddress = localStorage.getItem("isBindAddress");
      // console.log(this.isBindAddress);
      //  console.log(this.userId);
      if (this.userEmail !== null) {
        this.userEmail = getSubStr(this.userEmail, 0, 4);
      }
    }
    window.addEventListener("scroll", this.scrollFn, false);
  },
  methods: {
    debounceToggleDetails(index) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.toggleDetails(index);
      }, 100);
    },
    Exits() {
      this.lflog = true;
      this.testflog = false;
    },
    formattedDate(val) {
      const date = new Date(val);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    async GettProductdatails() {
      const params = {
        productId: this.pageNum,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GettProduct(formData);
    },
    async GetProductLists() {
      const params = {
        pageNum: this.pageNum,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetProductList(formData);
      // console.log(data);
      // console.log(data);
      this.listitems = data.result.list;
      //console.log(this.listitems);
    },
    hashsubmit1() {
      this.$message("Coming Soon");
    },
    async hashsubmit() {
      // let config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //     jwtToken: this.jwtToken,
      //   },
      // };
      if (this.coinTxHash == "" || this.txHash == "") {
        this.$message("The Hash cannot be empty");
        return false;
      }
      const params = {
        userId: localStorage.getItem("userId"),
        coinTxHash: this.coinTxHash,
        txHash: this.txHash,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetInfo(formData);
      // let data = await GetInfo(formData,config);
      if (data.code == 200) {
        this.$message(data.result);
        this.coinTxHash = "";
        this.txHash = "";
      } else {
        this.$message(data.result);
      }
      //console.log(data.result);
    },
    donation(val) {
      //console.log(val);
      this.donationAddress = val;
    },
    coinTypes(val) {
      this.coinType = val;
    },
    xprl(val) {
      // console.log(val);
      this.xprlAddress = val;
    },
    isBind(val) {
      this.isBindAddress = val;
      // console.log(this.isBindAddress);
    },
    email(val) {
      this.userEmail = val;
      this.testflog = true;
      // console.log(this.userEmail);
    },
    fflog(val) {
      this.flogc = val;
    },
    repwd(val) {
      //   console.log("接受重置repwd的值", val);
      this.flogc = val;
    },
    back() {
      this.flogc = false;
    },
    async recordlist() {
      this.rflog = true;
      this.testflog = false;
      const params = {
        userId: localStorage.getItem("userId"),
        pageNum: this.pageNum,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await GetTranstionList(formData);
      // console.log(data);
      this.total = data.result.count;
      this.relist = data.result.list;
    },
    bindclick() {
      this.bflog = true;
      this.testflog = false;
    },
    showaddressbox() {
      // console.log(2323);
      // console.log(this.testflog);
      this.testflog = true;
    },
    hideaddressbox() {
      this.testflog = false;
    },
    bindclose() {
      this.testflog = false;
    },
    // toggleDetails(index) {
    //   // this.flogs = true;
    //   // this.flogs1 = false;
    // },
    // hidetoggleDetails() {
    //   this.detailsVisible = null;
    // },
    async toggleDetails(index) {
      if (this.detailsVisible === index) {
        this.detailsVisible = null;
      } else {
        const params = {
          productId: this.listitems[index].productId,
          pageNum: this.pageNum,
          pageSize: 10,
        };

        const formData = new FormData();
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            formData.append(key, params[key]);
          }
        }

        try {
          const data = await GettProduct(formData);
          this.markList = data.result.markList;
          // Format dates if necessary
          for (let i = 0; i < this.markList.length; i++) {
            this.markList[i].holdTime = this.formattedDate(
              this.markList[i].holdTime
            );
          }

          // Set the detailsVisible after data has been fetched and processed
          this.detailsVisible = index;
        } catch (error) {
          console.error("Error fetching product details:", error);
        }
      }
    },

    hidetoggleDetails() {
      this.detailsVisible = null;
    },

    handleTouchMove(event) {
      if (this.detailsVisible !== null) {
        const touch = event.touches[0];
        const target = document.elementFromPoint(touch.clientX, touch.clientY);
        if (!this.$el.contains(target)) {
          this.hidetoggleDetails();
        }
      }
    },

    // formattedDate(date) {
    //   // Implement your date formatting logic here
    //   return date;
    // },
    update() {
      this.bflog = true;
    },
    logouts(val) {
      this.lflog = val;
      // this.flog = true;
      // console.log(this.lflog);
    },
    signups(val) {
      // console.log(val);
      this.flogb = val;
    },
    loginflog(val) {
      //   console.log("接受login的值", val);
      this.flog = val;
    },
    bloginflog(val) {
      this.bflog = val;
    },
    bloflog(val) {
      this.rflog = val;
    },
    login() {
      this.flog = true;
    },
    noteClick(val){
      this.rflog = val;
    },
    showTestbox() {
      // alert(11);
      this.testflog1 = true;
    },
    showTestbox1() {
      this.testflog1 = true;
    },
    hideTestbox1() {
      this.testflog1 = false;
    },
    async submitForm(formName) {
      //  console.log(formName);
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (formName != "") {
        if (formName != "" && !regEmail.test(formName)) {
          this.$message({
            message: "Email must be formatted correctly",
            type: "error",
          });
          this.ruleForm.email = "";
        } else {
          let formData = new FormData();
          let params = {
            email: this.ruleForm.email,
          };
          // console.log("params", params);
          let item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          //   console.log(formData);
          let data = await GetEmail(formData);
          if (data.code == 200) {
            this.$message({
              showClose: true,
              message: "Mailbox subscription succeeded",
              type: "success",
            });
          } else {
            this.$message({
              message: data.result,
              type: "error",
            });
            return false;
          }
          this.ruleForm.email = "";
        }
      } else {
        this.$message({
          message: "Please enter your e-mail address",
          type: "error",
        });
      }

      // this.$refs[formName].validate((valid) => {
      //   console.log(valid);
      //   if (valid) {
      //     alert("submit!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    toggleVisibilitya() {
      // 切换isVisible的值来控制元素的显示和隐藏
      this.isVisiblea = !this.isVisiblea;
    },
    toggleVisibility() {
      // 切换isVisible的值来控制元素的显示和隐藏
      this.isVisible = !this.isVisible;
    },
    getInfo() {
      if (
        this.form.fullName.length >= 1 &&
        this.form.email.length >= 1 &&
        this.form.content.length >= 1
      ) {
        this.btnShow = true;
      } else {
        this.btnShow = false;
      }
    },
    scrollFn() {
      let page = document.body.scrollHeight;
      let client = document.documentElement.clientHeight;
      let comend = page - client;
      let scrTop = document.documentElement.scrollTop + 220;
      // console.log(scrTop);
      this.percentage = Number(Math.round((scrTop / comend) * 10000) / 10);
      // console.log(this.percentage);
      if (this.percentage > 100) {
        this.percentage = 100;
      }
      this.percentagea =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 280;
      this.percentageb =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 290;
      this.percentagec =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 300;
      this.percentaged =
        Number(Math.round((scrTop / comend) * 10000) / 10) - 310;

      if (this.percentagea >= 100) {
        this.percentagea = 100;
      } else if (this.percentagea <= 0) {
        this.percentagea = 10;
      }

      if (this.percentageb >= 100) {
        this.percentageb = 100;
      } else if (this.percentageb <= 0) {
        this.percentageb = 10;
      }
      if (this.percentagec >= 100) {
        this.percentagec = 100;
      } else if (this.percentagec <= 0) {
        this.percentagec = 10;
      }
      if (this.percentaged >= 100) {
        this.percentaged = 100;
      } else if (this.percentaged <= 0) {
        this.percentaged = 10;
      }
    },

    originNavClick() {
      this.$router.push("/");
      if (sessionStorage.getItem("currentPath")) {
        sessionStorage.removeItem("currentPath");
      }
      this.currentPath = "";
    },
    goPage(url) {
      this.$router.push(url);
      this.show = false;
      this.shows1 = false;
      this.currentPath = url;
      sessionStorage.setItem("currentPath", url);
    },

    showUserMenu(item) {
      this.userMenu = true;
      this.show = false;
      this.showsubmenu = true;
    },
    showUserInfo(name) {
      this.isLogin = false;
      this.userName = name;
    },
    check() {
      this.dialogVisible = true;
      this.dialogType = "check";
      this.shows2 = true;
      this.shows1 = false;
    },
    mEnter() {
      clearInterval(this.timer); //鼠标移入清除定时器
    },
    jump(id) {
      this.shows1 = false;
      var height = document.body.clientHeight;

      var aa = document.querySelector(id);
      // aa.style.backgroundColor="red";
      setTimeout(function () {
        document.querySelector(id).scrollIntoView(true);
      }, 500);
      aa.scrollTo(0, height);
      document.querySelector(id).scrollIntoView(true);
      document.querySelector(id).scrollIntoView();
    },
    showNav() {
      this.shows1 = true;
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;
  margin-top: 120px !important;
  /* 其他样式调整，根据需要自行添加 */
}
@font-face {
  font-family: "Roboto";
  font-weight: normal;
  font-style: normal;
}
.el-progress__text {
  display: none;
}
.el-progress {
  background: none;
  // width: 80px;
  // position: relative;
  // height: 10px;
  // border: 1px solid red;
}
.el-progress-bar__outer {
  background: none;
}
.el-progress-bar__inner {
  background: #0b27f1;
  border-radius: 59px 59px 59px 59px;
}
.el-input__inner {
  width: 694px;
  height: 100px;
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  border: 3px solid #333333;
}
.el-textarea__inner {
  width: 694px;
  height: 400px;
  border-radius: 24px 24px 24px 24px;
  opacity: 1;
  border: 3px solid #333333;
}
.van-collapse-item__wrapper {
  background: #000;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px !important;
}

.van-collapse-item__content {
  background: #000;
  opacity: 0.5;
}
.van-collapse {
  position: absolute;
  left: 30px;
  width: 690px;
  overflow-y: scroll;
  height: 92%;
  margin-top: 107px;
}
.van-cell {
  height: 120px;
  // border: 1px solid red;
  line-height: 80px;
  opacity: 0.95 !important;
}
.nav-header {
  width: 100vw;
  height: 210px;
  background: #000;
  .content {
    position: fixed;
    top: 0px !important;
    left: 0px;
    right: 0px;
    .navcontent{
      display: flex;
      overflow: hidden;
      height: constant(100);
      height: env(100);
      z-index: 99;
      padding-right: 42px;
      height: 110px;
      background: #000;
      justify-content: space-between;
      align-items: center;
    }
    .message{
      font-weight: 500;
      font-size: 30px;
      color: #FFFFFF;
      .marquee-container {
        width: 100vw;
        margin: 0 auto;
        overflow: hidden;
        white-space: nowrap;
        background-color: rgba(0, 0, 0, 0); /* 黑色，50% 透明度 */
        padding: 5px 0;
        position: relative;
      }
      .marquee-content {
        display: inline-block;
        padding-left: 100%;
        animation: marquee linear infinite;
        color: #ffffff;
        font-weight: bold;
      }
      .marquee-message {
        width: 82vw;
        height: 60px;
        background: rgba(255,255,255,0.16);
        border-radius: 4px 4px 4px 4px;
        align-items: center;
        vertical-align: middle;
        display: flex;
        justify-content: center;
        span{
          line-height: 44px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        img{
          width: 32px;
          height: 33px;
          text-align: center;
          vertical-align: middle;
        }
      }
    }

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
    .title1 {
      font-size: 30px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 800;
      color: #141414;
      line-height: 39px;
      margin-left: 10px;
    }
    .subTitle {
      font-family: Roboto-Medium, Roboto;
    }
    div {
      display: flex;
      align-items: center;
    }
    .l {
      width: 231.69px;
      height: 58.67px;
      opacity: 1;
      margin-right: 17px;
      margin-left: 30px;
      img {
        width: 338px;
        height: 52px;
      }
    }
    .logo {
      width: 232px;
      height: 42.58px;
    }
    .l2 {
      width: 84px;
      height: 62px;
      margin-left: 15px;
    }
    .r {
      font-family: Poppins, Poppins;
      font-weight: 400;
      font-size: 30px;
      color: rgba(255, 255, 255, 0.95);
      display: flex;
      text-align: center;
      .signin {
        // width: 82px;
        height: 50px;
        padding-left: 24px;
        padding-right: 24px;
        margin-right: 40px;
        text-align: center;
        line-height: 50px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
      }
      .signin1 {
        margin-right: 12px;
      }
      img {
        width: 48px;
        height: 48px;
      }
    }
  }
  .addressbox {
    position: absolute;
    top: 120px;
    left: 36px;
    cursor: default;
    z-index: 9999;
    background: #202020;
    border-radius: 20px 20px 20px 20px;
    .boxli {
      width: 600px;
      margin: 0 auto;
      .boxlitit {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.6);
        height: 42px;
        line-height: 42px;
        margin-top: 32px;
        text-align: left;
      }
      .boxlicon {
        height: 36px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 24px;

        line-height: 36px;
        margin-top: 4px;
        color: #ffffff;
        text-align: left;
        img {
          width: 36px;
          height: 36px;
          margin-top: 6px;
          cursor: pointer;
        }
        input {
          border: none;
          border-bottom: 1px solid #5b5b5b;
          height: 29px;
          width: 319px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          width: 600px;
          color: #ffffff;
        }
      }
    }
    .boxlis {
      margin-top: 26px;
    }
    .boxbox {
      width: 598px;
      height: 280px;
      background: #000000;
      border-radius: 10px 10px 10px 10px;
      .boxlitit {
        width: 558px;
        margin: 0 auto;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.6);
        // height: 62px;
        line-height: 92px;
      }
      .boxlicon {
        width: 558px;
        margin: 0 auto;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 24px;
        color: #ffffff;
        height: 82px;
        line-height: 82px;
        margin-top: 4px;
        input {
          border: none;
          border-bottom: 1px solid #5b5b5b;
          height: 29px;

          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          width: 558px;
          color: #ffffff;
        }
      }
    }
    .recordbox {
      display: flex;
      justify-content: space-between;
      width: 598px;
      margin: 0 auto;
      margin-top: 32px;
      // border: 1px solid red;
      .record {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: #3cf6f0;
        width: 300px;
        height: 56px;
        line-height: 56px;
      }
      .record1 {
        width: 150px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background: #3cf6f0;
        border-radius: 162px 162px 162px 162px;
      }
      .record11 {
        width: 150px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background: #a1a1a1;
        border-radius: 162px 162px 162px 162px;
      }
    }
    .Reminder {
      margin-left: 40px;
      margin-top: 40px;
      .Remindertit {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
        text-align: left;
      }
      .Remindercon {
        width: 598px;
        height: 108px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 24px;
        color: #a1a1a1;
        line-height: 36px;
        text-align: left;
        margin-top: 4px;
      }
      .Remindercon1 {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 36px;
        color: #3cf6f0;
        text-align: center;
        margin-top: 40px;
      }
    }
    .boxbind {
      display: flex;
      .exit {
        margin-top: 44px;
        width: 116px;
        height: 56px;
        line-height: 56px;
        background: #2a2a2a;
        border-radius: 162px 162px 162px 162px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 26px;
        text-align: center;
        color: #3cf6f0;
        margin-left: 40px;
        margin-right: 40px;
      }
      .bind {
        width: 312px;
        height: 56px;
        line-height: 56px;
        background: #3cf6f0;
        border-radius: 162px 162px 162px 162px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 26px;
        color: #202020;
        text-align: center;
        margin-top: 44px;
        // margin-left: 200px;
      }
    }
  }
  .addressbox1 {
    width: 548px;
    height: 478px;
    left: 84px !important;
    .close {
      width: 36px;
      height: 36px;
      margin-top: 20px;
      margin-left: 468px;
    }
    .boxli {
      width: 468px;
      margin: 0 auto;
      .boxlitit {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.6);
        height: 42px;
        line-height: 42px;
      }
      .boxlicon {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 24px;
        color: #ffffff;
        height: 42px;
        line-height: 42px;
        margin-top: 4px;
      }
    }
  }
  .addressbox2 {
    width: 678px;
    height: 998px;
    background: #202020;
    border-radius: 20px 20px 20px 20px;
    .close {
      width: 36px;
      height: 36px;
      margin-left: 618px;
      margin-top: 20px;
    }
  }
  .navTag {
    width: 100vw;
    height: 100vh;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    overflow-y: scroll;
    display: inline-flex;
    flex-direction: column;
    // background: #131313;
    background: #000;
    .Ecological {
      background: #000 !important;
      i {
        display: none !important;
      }
      .van-collapse-item__wrapper {
        display: none;
      }
    }

    .navtitle {
      width: 100%;
      height: 107px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        display: flex;
        align-items: center;
      }
      .l {
        width: 231.69px;
        height: 108.6px;
        opacity: 1;
        margin-right: 17px;
        margin-left: 30px;
        img {
          width: 340px;
          height: 60px;
        }
      }
      .title1 {
        font-family: Roboto-Medium, Roboto;
        font-size: 30px;
        font-weight: 800;
        color: #141414;
        line-height: 110px;
        text-align: left;
        margin-left: 10px;
      }
      .r {
        width: 70px;
        height: 70px;
        margin-right: 40px;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 30px;
        color: rgba(255, 255, 255, 0.95);
      }
    }
    .headermenu {
      width: 690px;
      margin: 0 auto;
      margin-top: 58px;
      .menuli {
        width: 688px;
        text-align: left;
        height: 60px;
        line-height: 60px;
        margin-bottom: 8px;
        background: #000000;
        border-radius: 0px 0px 0px 0px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
      }
    }
    .headermenu1 {
      width: 690px;
      margin: 0 auto;
      margin-top: 46px;
      .headertip {
        display: flex;
        justify-content: space-between;
        .headertipl {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 28px;
          color: #ffffff;
        }
        .headertipr {
          img {
            width: 28px;
            height: 28px;
          }
        }
      }
      .headerlist {
        text-align: left;
        div {
          height: 42px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 28px;
          color: #ffffff;
          line-height: 42px;
          margin-top: 16px;
        }
      }
    }
    .highlight {
      color: #cf61dc;
      opacity: 1;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: normal;
    }
  }
  .bottom {
    flex: 1;
    width: 100%;
    background: #202020;
    border-radius: 0px 0px 0px 0px;
  }
  .bot {
    width: 650px;
    height: 660px;
    left: 50px;
    position: relative;
    top: 20px;
    text-align: center;
    .dialog {
      margin: 0 auto;
      margin-bottom: 60px;
      img {
        width: 100px;
        height: 100px;
        opacity: 1;
      }
    }
    .community {
      margin-bottom: 40px;
      img {
        margin-right: 40px;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.01);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }
    }
    .bottom-copyright {
      margin: 0 20px 10px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 30px;
    }
  }



}
</style>

<style lang="less" scoped>
@font-face {
  font-family: "Poppins-ExtraBold";
  src: url("../../assets/font/Poppins-ExtraBold.ttf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Poppins-Regular";
  src: url("../../assets/font/Poppins-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Poppins-SemiBold Italic";
  src: url("../../assets/font/Poppins-SemiBoldItalic.ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Poppins-SemiBold";
  src: url("../../assets/font/Poppins-SemiBold.ttf");
  font-weight: normal;
  font-style: normal;
}

.appcontent {
  width: 750px;
  margin: 0px auto 0px auto;
  background: #000;
  text-align: center;
  .content-topa {
    background: #000;
    height: 80px;
    width: 750px;
  }
  .content-top {
    width: 100%;
    background: #000;
    .Aboutbg {
      background: url(../../assets/pc/Index/banner.png) center/cover no-repeat;
      width: 690px;
      height: 664px;
      margin: 0 auto;
      .Aboutitle {
        text-align: center;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
        padding-top: 180px;
      }
      .Aboutcon {
        font-family: Poppins, Poppins;
        font-weight: 700;
        font-size: 74px;
        color: #ffffff;
        line-height: 80px;
        span {
          filter: blur(4px);
        }
      }
      .Aboutcon1 {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
        line-height: 42px;
        margin-top: 4px;
      }
      .Aboutbotm {
        display: flex;
        justify-content: space-between;
        margin-top: 80px;

        .Aboutbotml {
          text-align: left;
          // margin-left: 30px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          color: #ffffff;
          line-height: 28px;
        }
        .Aboutbotmr {
          margin-right: 30px;
          margin-top: 64px;
          img {
            width: 48px;
            height: 48px;
          }
        }
      }
    }
  }
  .content-toptop {
    width: 750px;
    // height: 640px;
    background: #000;
    height: 130px;
  }
  .content-top1 {
    padding-top: 26px;
    width: 750px;
    // height: 640px;
    background: #000;
    opacity: 1;
    .top1titl {
      //  position: relative;
      width: 690px;
      margin: 0 auto;
      .aboutMission {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 56px;
        color: #ffffff;
        line-height: 84px;
        text-align: left;
        img {
          width: 24px;
          height: 20px;
          margin-top: 42px;
          margin-left: 8px;
        }
      }
      .aboutli1 {
        margin-bottom: 96px;
      }
      .aboutli {
        margin-top: 36px;
        .aboutcon {
          text-align: left;
          .abouttit {
            font-family: Poppins-SemiBold;
            font-weight: 600;
            font-size: 40px;
            color: #ffffff;
            line-height: 60px;
          }
          .aboutcon {
            font-family: Poppins-Regular;
            font-weight: 500;
            font-size: 24px;
            color: #fff;
            line-height: 36px;
            text-align: left;
            span {
              color: #01afa9;
            }
          }
          .img1 {
            width: 520px;
            height: 108px;
          }
          .img2 {
            width: 402px;
            height: 108px;
          }
          .img3 {
            width: 404px;
            height: 106px;
          }
        }
      }
    }
  }
  .content-top1a {
    width: 750px;
    height: 100px;
    background: #000;
  }
  .content-top2a {
    width: 750px;
    height: 120px;
    background: #000;
  }
  .content-top2 {
    width: 750px;
    // height: 1669px;
    background: #000;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding-top: 80px;
    .Main-w {
      width: 690px;
      margin: 0 auto;
      .aboutMission {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 56px;
        color: #ffffff;
        line-height: 84px;
        text-align: left;
        img {
          width: 24px;
          height: 20px;
          margin-top: 42px;
          margin-left: 8px;
        }
      }
      img {
        margin-top: 32px;
        width: 690px;
        height: 498px;
      }
    }
  }
  .content-top3 {
    width: 750px;
    background: #000;
    position: relative;
    .top3titl {
      width: 690px;
      margin: 0 auto;
      background: #000;
      // padding-top: 20px;
      .aboutMission {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 56px;
        color: #ffffff;
        line-height: 84px;
        text-align: left;
        img {
          width: 24px;
          height: 20px;
          margin-top: 42px;
          margin-left: 8px;
        }
      }
      .Processbox {
        margin-top: 78px;
        .Processimg {
          width: 690px;
          height: 1612px;
          background: url(../../assets/m/Index/26.svg) center/cover no-repeat;
        }
        .div1 {
          margin-top: 92px;
          margin-left: 362px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 28px;
          color: #ffffff;
          padding-top: 10px;
        }
        .div2 {
          margin-top: 120px;
          margin-right: 398px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 28px;
          color: #ffffff;
          text-align: right;
        }
        .div3 {
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 28px;
          color: #ffffff;
          margin-top: 160px;
        }
        .div4 {
          width: 220px;
          height: 60px;
          line-height: 60px;
          background: #00cdc6;
          border-radius: 394px 394px 394px 394px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 24px;
          color: #000000;
          margin-top: 40px;
        }
        .div5 {
          width: 296px;
          height: 60px;
          line-height: 60px;
          background: #00cdc6;
          border-radius: 394px 394px 394px 394px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 24px;
          color: #000000;
          margin-top: 40px;
        }
        .bfb {
          display: flex;
          margin-top: 68px;
          .icons {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 24px;
            color: #ffffff;
            margin-left: 36px;
          }
          .icons1 {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 24px;
            color: #ffffff;
            margin-left: 188px;
          }
        }
        .bfb1 {
          display: flex;
          margin-top: 268px;
          .icons {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 24px;
            color: #ffffff;
            margin-left: 36px;
          }
          .icons1 {
            margin-top: 42px;
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 24px;
            color: #ffffff;
            margin-left: 230px;
          }
        }
        .bfb2 {
          display: flex;

          .icons {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 24px;
            color: #ffffff;
            margin-left: 316px;
            margin-top: 348px;
          }
          .icons1 {
            margin-top: 42px;
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 24px;
            color: #ffffff;
            margin-top: 348px;
            margin-left: 120px;
          }
        }
        .pbox {
          display: flex;
          //border: 1px solid red;
          .div7 {
            display: flex;
            flex-direction: column;
            margin-top: 82px;
            // width: 192px;
            margin-left: 32px;
            // border: 1px solid red;
            .diva {
              width: 62px;
              height: 30px;
              line-height: 30px;
              background: #000000;
              border-radius: 15px 15px 15px 15px;

              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #ffffff;
              line-height: 30px;
            }
            .divb {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #000000;
              line-height: 36px;
              text-align: left;

              margin-top: 6px;
            }
          }
          .div8 {
            display: flex;
            flex-direction: column;
            margin-top: 82px;
            border: 1px solid red;
            // width: 192px;
            // margin-left: 32px;

            .diva {
              width: 62px;
              height: 30px;
              line-height: 30px;
              background: #000000;
              border-radius: 15px 15px 15px 15px;
              margin-left: 64px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #ffffff;
              line-height: 30px;
            }
            .divb {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #000000;
              line-height: 36px;
              text-align: left;
              margin-left: 64px;
              margin-top: 6px;
            }
          }
        }
        .pbox {
          display: flex;
          //border: 1px solid red;

          .div9 {
            display: flex;
            flex-direction: column;
            margin-top: 114px;
            .diva {
              width: 62px;
              height: 30px;
              line-height: 30px;
              background: #000000;
              border-radius: 15px 15px 15px 15px;
              margin-left: 32px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #ffffff;
              line-height: 30px;
            }
            .divb {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #000000;
              line-height: 36px;
              text-align: left;
              margin-left: 32px;
              margin-top: 6px;
            }
          }
          .div10 {
            display: flex;
            flex-direction: column;
            margin-top: 114px;
            .diva {
              width: 62px;
              height: 30px;
              line-height: 30px;
              background: #000000;
              border-radius: 15px 15px 15px 15px;
              margin-left: 54px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #ffffff;
              line-height: 30px;
            }
            .divb {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #000000;
              line-height: 36px;
              text-align: left;
              margin-left: 54px;
              margin-top: 6px;
            }
          }
        }
        .div6 {
          width: 488px;
          height: 94px;
          background: #00cdc6;
          border-radius: 394px 394px 394px 394px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 24px;
          color: #000000;
          line-height: 36px;
          text-align: left;
          padding-top: 12px;
          padding-left: 28px;
          margin-top: 610px;
        }
        .pbox {
          display: flex;
          //border: 1px solid red;
          .div11 {
            display: flex;
            flex-direction: column;
            margin-top: 108px;
            .diva {
              width: 62px;
              height: 30px;
              line-height: 30px;
              background: #000000;
              border-radius: 15px 15px 15px 15px;
              margin-left: 308px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #ffffff;
              line-height: 30px;
            }
            .divb {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #000000;
              line-height: 36px;
              text-align: left;
              margin-left: 308px;
              margin-top: 6px;
            }
          }
          .div12 {
            display: flex;
            flex-direction: column;
            margin-top: 108px;
            .diva {
              width: 62px;
              height: 30px;
              line-height: 30px;
              background: #000000;
              border-radius: 15px 15px 15px 15px;
              margin-left: 54px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #ffffff;
              line-height: 30px;
            }
            .divb {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #000000;
              line-height: 36px;
              text-align: left;
              margin-left: 54px;
              margin-top: 6px;
            }
          }
        }
      }
    }
  }
  .content-top4a {
    width: 750px;
    height: 120px;
    background: #000;
  }
  .content-top4 {
    width: 750px;

    background: #000;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    .top4_main {
      width: 690px;
      margin: 0 auto;
      padding-top: 100px;
      .aboutMission {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 56px;
        color: #ffffff;
        line-height: 84px;
        text-align: left;
        img {
          width: 24px;
          height: 20px;
          margin-top: 42px;
          margin-left: 8px;
        }
      }
      .Nftimg {
        width: 300px;
        height: 300px;
        margin-top: 60px;
      }
      .Nftcon {
        margin-top: 34px;
        img {
          width: 20px;
          height: 20px;
          margin-top: 12px;
          margin-right: 10px;
        }
        span {
          font-family: Poppins-SemiBold;
          font-weight: 600;
          font-size: 32px;
          color: #3cf6f0;
          line-height: 48px;
        }
      }
      .Nftcon1 {
        margin-top: 20px;
        margin-bottom: 52px;
        img {
          width: 20px;
          height: 20px;
          margin-top: 12px;
          margin-right: 10px;
        }
        span {
          font-family: Poppins-SemiBold;
          font-weight: 600;
          font-size: 32px;
          color: #f2f2f2;
          line-height: 48px;
        }
      }
      .Nftli {
        display: flex;

        .Nftlileft {
          // margin-top: 6px;
          .Nftline {
            width: 1px;
            background: #fff;
            margin-left: 3.5px;
            padding-top: 6px;
            padding-bottom: 6px;
          }
          .lineheight {
            height: 134px;
          }
          .lineheight1 {
            height: 98px;
          }
          .lineheight2 {
            height: 168px;
          }
          .Nftdian {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #fff;
            // margin-top: 6px;
          }
        }
        .Nftliright {
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          color: #ffffff;
          line-height: 36px;
          text-align: left;
          margin-left: 14px;
          span {
            color: #3bfff8;
          }
        }
        .Nftlirighta {
          margin-top: 14px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          color: #ffffff;
          line-height: 36px;
          text-align: left;
          margin-left: 20px;
          span {
            color: #3bfff8;
          }
        }
      }
    }
  }
  .content-top5a {
    background: #000;
    width: 750px;
    height: 28px;
  }
  .content-top5 {
    background: #fff;
    width: 750px;
    .top5_main {
      width: 694px;
      margin: 0 auto;
      img {
        margin-top: 100px;
        width: 208px;
        height: 66px;
      }
      .top5_box {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 16px;
        .top5_boxul {
          position: relative;
          .top5_boxli {
            width: 333px;
            height: 381px;
            background: #2f47ee;
            border-radius: 24px 24px 24px 24px;
            opacity: 1;
            border: 0px solid #000000;
            img {
              width: 39px;
              height: 303px;
              position: absolute;
              top: -100px;
              right: 0;
            }
          }
          .top5_text {
            margin-top: 21px;
            font-size: 36px;
            font-family: Poppins-Medium, Poppins;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
            letter-spacing: 1px;
          }
          .top5_con {
            font-size: 24px;
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #000000;
            line-height: 32px;
            margin-top: 10px;
            margin-bottom: 32px;
          }
        }
        .top5_boxul:nth-child(5) {
          margin-left: 180px;
          margin-bottom: 0px !important;
        }
      }
    }
  }
  .content-top6a {
    background: #000;
    height: 120px;
  }
  .content-top6 {
    background: #000;
    // margin-top: 69px;
    .top6_main {
      width: 690px;
      margin: 0 auto;
      // padding-bottom: 120px;
      .Foundationtip {
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 56px;
        color: #ffffff;
        line-height: 84px;
        text-align: left;
        margin-bottom: 104px;
        img {
          width: 24px;
          height: 20px;
          margin-top: 42px;
          margin-left: 8px;
        }
      }
      .Foundationli {
        margin-top: 30px;
        .Foundationlibox {
          display: flex;

          .Foundcon {
            width: 32px;
            height: 32px;
            background: #00cdc6;
            border-radius: 50%;
            line-height: 32px;
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 26px;
            text-align: center;
            color: #000000;
            margin-top: 8px;
            margin-right: 12px;
          }
          .concontent {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 30px;
            color: #ffffff;
            line-height: 46px;
            margin-left: 12px;
            margin-top: 2px;
            // margin-left: 19px;
          }
          .concontent1 {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 30px;
            color: #ffffff;
          }
          .img {
            width: 42px;
            height: 42px;
            margin-left: 6px;
            margin-top: 4px;
          }
          .img1 {
            width: 40px;
            height: 40px;
            margin-left: 6px;
          }
          .concontent2 {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 30px;
            color: #ffffff;
          }
          .img2 {
            width: 36px;
            height: 36px;
            margin-right: 12px;

            // margin-top: 10px;
          }
        }
      }
      .Foundline {
        border: 2px solid rgba(216, 216, 216, 0.3);
        width: 690px;
        margin-top: 30px;
      }
      .Foundbox {
        margin-top: 60px;

        // display: flex;
        .Foundboxli {
          width: 690px;
          height: 176px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #ffffff;
          margin-right: 50px;
          padding-top: 16px;
          padding-left: 16px;
          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 24px;
          color: #ffffff;
          line-height: 36px;
          text-align: left;
          margin-top: 40px;
        }
        .Foundboxlia {
          height: 216px !important;
        }
        .Foundboxli:hover {
          // background: url();
          background: url("../../assets/m/Index/17.png") center/cover no-repeat;
          width: 690px;
          height: 176px;
          border: none;
        }
      }
      .Foundboxline {
        margin-top: 48px;
        height: 27px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #3cf6f0;
        line-height: 42px;
        text-align: left;
        // padding-bottom: 120px;
        img {
          width: 36px;
          height: 36px;
        }
      }
      .Foundboxall {
        margin-top: 20px;

        .tab {
          display: flex;
          width: 478px;
          height: 74px;
          border-radius: 20px 20px 20px 20px;
          border: 2px solid #00cdc6;
        }
        button {
          border: none;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 26px;
          color: #ffffff;
          margin-left: 20px;
          word-spacing: 0px;
          margin-right: 6px;
          width: 244px;
        }
        .active {
          width: 244px;
          height: 58px;
          background: #00cdc6;
          border-radius: 12px 12px 12px 12px;
          text-align: center;
          line-height: 58px;
          margin: 6px 8px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 26px;
          color: #000000;
          word-spacing: 0px;
        }
        .tab-content {
          margin-top: 20px;
          .nodata {
            width: 478px;
            height: 160px;
            line-height: 160px;
            text-align: center;
            border-radius: 20px 20px 20px 20px;
            border: 2px solid #00cdc6;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 28px;
            color: #ffffff;
          }
          .tabcontent {
            width: 628px;
            height: 332px;
            border-radius: 20px 20px 20px 20px;
            border: 2px solid #00cdc6;
            overflow: hidden;

            .tabtitle {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: rgba(255, 255, 255, 0.8);
              border-bottom: 1px solid rgba(216, 216, 216, 0.5);
              text-align: left;
              margin-left: 32px;
              height: 76px;
              line-height: 76px;
              margin-right: 32px;
            }
            .tabbox {
              overflow-y: auto;
              .tabboxli {
                height: 42px;
                font-family: Poppins, Poppins;
                font-weight: 400;
                font-size: 28px;
                color: #ffffff;
                line-height: 42px;
                margin-top: 16px;
                margin-bottom: 16px;
              }
            }
            /* 设置滚动条的宽度和背景颜色 */
            .tabbox::-webkit-scrollbar {
              width: 0px; /* 对于垂直滚动条，设置宽度 */
              height: 10px; /* 对于水平滚动条，设置高度 */
              background-color: #f9f9f9; /* 滚动条的背景色 */
            }
          }
        }
      }
    }
  }
  .Foundationa {
    width: 750px;
    height: 120px;
    background: #000;
  }
  .Foundation {
    background: url("../../assets/pc/Index/15.png") center/cover no-repeat;
    height: 402px;
    .aboutMission {
      font-family: Poppins-SemiBold Italic;
      font-weight: 600;
      font-size: 56px;
      color: #ffffff;
      line-height: 70px;
      height: 70px;
      text-align: left;
      padding-top: 30px;
      margin-left: 30px;
      margin-bottom: 20px;
      img {
        width: 24px;
        height: 20px;
        margin-top: 30px;
        margin-left: 8px;
      }
    }
    .Foundationcon {
      margin-top: 50px;
      margin-left: 30px;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 24px;
      color: #ffffff;
      line-height: 36px;
      text-align: left;
    }
  }
  .content-top7 {
    background: #fff;
    width: 750px;
    .top7_main {
      width: 694px;
      margin: 0 auto;
      .top7_company {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .company_img {
          width: 305px;
          height: 91px;
          // border: 1px solid #999;
          margin-bottom: 63px;
          margin-right: 56px;
          .img1 {
            width: 275px;
            height: 91px;
          }
          .img2 {
            width: 294px;
            height: 47px;
          }
          .img3 {
            width: 344px;
            height: 45px;
          }
          .img4 {
            width: 223px;
            height: 60px;
          }
          .img5 {
            width: 49px !important;
            height: 60px !important;
          }
          .img6 {
            width: 223px;
            height: 57px;
          }
        }
        .company_img:nth-child(even) {
          margin-right: 0px !important;
        }
      }
    }
  }
  #Products {
    height: 198px;
    background: #000;
  }
  .Products {
    // margin-top: 198px;
    background: #000;
    .Productsallbox {
      width: 690px;
      margin: 0 auto;
      // display: flex;
      .Productstit {
        width: 690px;
        height: 70px;
        font-family: Poppins-SemiBold Italic;
        font-weight: 600;
        font-size: 56px;
        color: #ffffff;
        line-height: 70px;
        text-align: left;
        img {
          width: 24px;
          height: 20px;
          margin-top: 26px;
        }
      }

      .Productsbox {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .pboxli {
          position: relative;
          width: 328px;
          background: linear-gradient(
            180deg,
            rgba(9, 11, 11, 0.02) 0%,
            #090b0b 100%
          );
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #30393a;
          margin-bottom: 40px;
          .pboxlibox {
            margin-left: 30px;
            // margin: 0 auto;
            text-align: left;

            .imgs {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              background: #fff;
              margin-top: 40px;
            }
            .pboxboxs {
              position: absolute;
              left: -1px;
              // top: 600px;
              background: #090b0b;
              border: 1px solid #30393a;
              border-top: none;
              border-radius: 0px 0px 10px 10px;
              z-index: 9999;
              width: 328px;

              .pboxlitit {
                // height: 38px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 30px;
                color: #ffffff;
                line-height: 38px;
                text-align: left;
                margin-top: 24px;
                margin-bottom: 14px;
              }
              // .pboxlitit:first-child{
              //   width: 286px;

              //   border-top: 1px solid #30393a;
              // }
              .pboxlicon {
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                .pboxlileft {
                  height: 36px;
                  font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 24px;
                  color: rgba(255, 255, 255, 0.6);
                  line-height: 36px;
                  margin-bottom: 4px;
                }
                .pboxliright {
                  height: 36px;
                  font-family: Poppins, Poppins;
                  font-weight: 400;
                  font-size: 24px;
                  color: #ffffff;
                  line-height: 36px;

                  margin-bottom: 26px;
                }
              }
              .pboxline {
                width: 286px;
                height: 0px;
                border: 1px solid #30393a;
                margin-top: 7px;
                margin-bottom: 14px;
              }
            }
            .pboxlitit {
              // height: 38px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 30px;
              color: #ffffff;
              line-height: 38px;
              text-align: left;
              margin-top: 24px;
              margin-bottom: 14px;
              word-break: -2px;
            }
            .pboxlicon {
              display: flex;
              flex-direction: column;
              // justify-content: space-between;
              .pboxlileft {
                // height: 36px;
                font-family: Poppins, Poppins;
                font-weight: 400;
                font-size: 24px;
                color: rgba(255, 255, 255, 0.6);
                line-height: 36px;
                margin-bottom: 4px;
              }
              .pboxliright {
                // height: 36px;
                font-family: Poppins, Poppins;
                font-weight: 400;
                font-size: 24px;
                color: #ffffff;
                line-height: 36px;

                margin-bottom: 26px;
              }
              .addrs {
                width: 286px;
                //border: 1px solid red;
                word-wrap: break-word;
                text-align: left;
              }
              .pboxlirighta {
                width: 200px; /* 定义容器宽度 */
                text-align: right;
                word-wrap: break-word;
                text-align: left;
              }
            }
            .pboxline {
              width: 286px;
              height: 0px;
              border: 1px solid #30393a;
              margin-top: 7px;
              margin-bottom: 14px;
            }
            .pboxviews {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 24px;
              color: #ffffff;
              text-align: center;
              padding-bottom: 18px;
              .imgview {
                width: 32px;
                height: 32px;
                margin-top: 2px;
                margin-left: 4px;
              }
            }
          }
        }
      }
    }
  }
  .footer {
    background: #000;
    .Main-w {
      width: 690px;
      margin: 0 auto;
      margin-top: 44px;
      .footerli {
        margin-top: 96px;
        display: flex;
        img {
          width: 60px;
          height: 60px;
        }
        .footerlicon {
          text-align: left;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 32px;
          color: #ffffff;
          line-height: 40px;
          margin-left: 16px;
        }
      }
      .footerlia {
        text-align: left;
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 42px;
        margin-top: 24px;
        margin-left: 76px;
        span {
          color: red;
        }
      }
      .footerlib {
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 28px;
        color: #ffffff;
        line-height: 36px;
        text-align: left;
        text-decoration-line: underline;
        margin-top: 24px;
        margin-left: 76px;
        word-break: break-all;
        img {
          width: 56px;
          height: 56px;
          margin-right: 8px;
        }
      }
      .demo-dynamic {
        margin-top: 12px;
        margin-left: 50px;

        /deep/ .el-input__inner {
          width: 614px;
          height: 80px;
          border-radius: 20px 20px 20px 20px;
          border: 2px solid #ffffff;

          font-family: Poppins, Poppins;
          font-weight: 400;
          font-size: 28px;
          color: rgba(255, 255, 255, 0.6);
          line-height: 42px;
          text-align: left;
          padding: 0 30px;
          background: #000;
        }
        /deep/ .el-button {
          width: 258px;
          height: 76px;
          background: #ffffff;
          border-radius: 20px 20px 20px 20px;

          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 28px;
          color: #000000;
          border: none;
          text-align: center;

          margin-left: 332px;
        }
      }
      .apks {
        width: 690px;
        height: 176px;
        background:url('../../assets/m/Index/bg.png') no-repeat;
        background-size: cover;
        .title {
          height: 60px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 40px;
          color: #ffffff;
          line-height: 60px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-left: 74px;
        }
        .download {
          width: 258px;
          height: 76px;
          background: #ffffff;
          border-radius: 20px 20px 20px 20px;
          /*font-family: Poppins, Poppins;*/
          font-weight: 600;
          font-size: 28px;
          color: #000000;
          line-height: 76px;
          text-align: center;
          margin: 0 auto;
          margin-top: 12px;
        }
      }
      .footerbottom {
        margin-top: 120px;
        padding-bottom: 66px;
        text-align: left;
        .bottomimg {
          width: 338px;
          height: 52px;
        }
        .bottombox {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 28px;
          color: #ffffff;
          img {
            width: 30px;
            height: 30px;
            margin-top: 2px;
          }
        }
        .footermain {
          display: flex;
          justify-content: space-between;
          .footermainl {
            margin-top: 40px;
            .div1 {
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 28px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 42px;
            }
            .div2 {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 28px;
              color: #ffffff;
              line-height: 42px;
            }
            .div3 {
              margin-top: 42px;
              font-family: Poppins, Poppins;
              font-weight: 400;
              font-size: 24px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 28px;
            }
            .div4 {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 28px;
              color: #ffffff;
              line-height: 42px;
              margin-top: 42px;
              img {
                width: 36px;
                height: 36px;
              }
            }
          }
          .footermainr {
            margin-right: 90px;
            margin-top: 40px;
            div {
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 28px;
              color: #ffffff;
              line-height: 42px;
              margin-bottom: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
